module.exports = __webpack_public_path__ + "img/google-merchant-logo.f65a2e2d.svg";